export default "__VITE_ASSET__DYikkDbR__"